import React from "react";
import { Link, Switch, Route, Redirect, useHistory, useLocation } from "react-router-dom";
import { useParent } from "../../../context/ParentContext";
import { ParentPermissionChecker } from "../../../services/ParentPermissionChecker";
import ParentDashboard from "./ParentDashboard";
import ParentProgress from "./ParentProgress";
import ParentResults from "./ParentResults";
import ParentFee from "./ParentFee";

const NAV_LINKS = [
  { to: "/parent/dashboard", label: "Dashboard",   permission: "parent.view_dashboard" },
  { to: "/parent/progress",  label: "Attendance",  permission: "parent.view_attendance" },
  { to: "/parent/results",   label: "Result Card", permission: "parent.view_results" },
  { to: "/parent/fee",       label: "Fee Challans", permission: "parent.view_fee" },
];

export default function ParentLayout() {
  const { childList, selectedChild, setSelectedChild } = useParent();
  const history = useHistory();
  const location = useLocation();

  function handleLogout() {
    localStorage.removeItem("parentToken");
    localStorage.removeItem("parentUser");
    localStorage.removeItem("parentChildren");
    history.push("/parent/login");
  }

  const isActive = (path) => location.pathname === path;

  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: "inherit" }}>

      {/* ── Sidebar ───────────────────────────────────────────── */}
      <aside
        style={{
          width: 220,
          background: "#1b1b28",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          flexShrink: 0,
        }}
      >
        {/* Brand */}
        <div
          style={{
            padding: "24px 20px 20px",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "#fdf012",
              letterSpacing: 1,
              textTransform: "uppercase",
            }}
          >
            Parent Portal
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 4 }}>
            School Management System
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: "16px 12px" }}>
          {NAV_LINKS.map((link) => {
            const allowed = ParentPermissionChecker(link.permission);
            if (!allowed) return null;
            return (
              <Link
                key={link.to}
                to={link.to}
                style={{
                  display: "block",
                  padding: "10px 14px",
                  borderRadius: 8,
                  marginBottom: 4,
                  color: isActive(link.to) ? "#fdf012" : "rgba(255,255,255,0.65)",
                  background: isActive(link.to)
                    ? "rgba(253,240,18,0.08)"
                    : "transparent",
                  textDecoration: "none",
                  fontWeight: isActive(link.to) ? 600 : 400,
                  fontSize: 14,
                  transition: "all 0.15s",
                }}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div style={{ padding: "16px 12px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          <button
            onClick={handleLogout}
            style={{
              width: "100%",
              padding: "9px 14px",
              background: "rgba(239,68,68,0.12)",
              color: "#f87171",
              border: "1px solid rgba(239,68,68,0.25)",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
              textAlign: "left",
            }}
          >
            Sign Out
          </button>
        </div>
      </aside>

      {/* ── Main area ─────────────────────────────────────────── */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>

        {/* Top nav */}
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 24px",
            height: 60,
            background: "#fff",
            borderBottom: "1px solid #e5e7eb",
            flexShrink: 0,
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 15, color: "#0f172a" }}>
            {selectedChild
              ? `${selectedChild.student?.name || "Student"} — ${selectedChild.student?.student_class?.name || ""}`
              : "No child selected"}
          </span>

          {/* Child selector */}
          {childList.length > 1 && (
            <select
              value={selectedChild?.id || ""}
              onChange={(e) => {
                const child = childList.find(
                  (c) => String(c.id) === String(e.target.value)
                );
                setSelectedChild(child || null);
              }}
              style={{
                padding: "7px 12px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 13,
                color: "#374151",
                background: "#f9fafb",
                cursor: "pointer",
              }}
            >
              {childList.map((child) => (
                <option key={child.id} value={child.id}>
                  {child.student?.name} — {child.student?.student_class?.name}
                </option>
              ))}
            </select>
          )}
        </header>

        {/* Page content */}
        <main
          style={{
            flex: 1,
            padding: 24,
            background: "#f9fafb",
            overflowY: "auto",
          }}
        >
          <Switch>
            <Route path="/parent/dashboard" component={ParentDashboard} />
            <Route path="/parent/progress"  component={ParentProgress}  />
            <Route path="/parent/results"   component={ParentResults}   />
            <Route path="/parent/fee"       component={ParentFee}       />
            <Redirect from="/parent" exact to="/parent/dashboard" />
          </Switch>
        </main>
      </div>
    </div>
  );
}
